import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
import Genres from '../genres/genres';
import moment from 'moment';
import ScheduleAdd from '../schedule/add';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import './fault.css';

export default class Fault extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			show: false,
			error: 0,
			channel: '',
			FaultListener: null,
		};
		this.close = this.close.bind(this);
		this.channelSelect = this.channelSelect.bind(this);
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		const FaultListener = EventEmitter.addListener('/video/fault', data => {
			const user = this.context;
			if( user.user.user.id === data.uid ) {
				this.setState({show: true, error: data.error, channel: data.channel?data.channel:''});
			}
		}); this.setState({FaultListener});

	}

	componentWillUnmount() {
		if( this.state.FaultListener ) this.state.FaultListener.remove();
	}

	close() {
		this.setState({ show: false });
	}
	
	async channelSelect(channel) {
		console.log(channel);
		let params = new URLSearchParams();
		params.append("channel", channel);
		let x = await postApi("/api/v2/rtmpchannel", params);
		this.setState({show: false, error: 0});
	}

	render() {
		//const user = this.context;
		return (
			<>
				{this.state.error === 100 &&
					<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
						<Modal.Header closeButton className="bg-dark">
							<Modal.Title>Unsupported Software</Modal.Title>
						</Modal.Header>
						<Modal.Body className="bg-dark">
							<Row>
								<Col xs={2}>
									<img src="/images/Virtualdj-2020-logo.png" width="100%" />
								</Col>
								<Col>
									<h2>Virtual DJ</h2>
									Virtual DJ is not supported by our streaming software and your streaming session has been disconnected.<br /><br />
									please use OBS instead. You can download the latest from their website:&nbsp;
									<a href="https://obsproject.com/" target="_blank" rel="noreferrer">https://obsproject.com/</a><br /><br />
									
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer className="bg-dark">
							{/*
							<Button variant="secondary" onClick={this.close}>
								Close
							</Button>
							*/}
							<Button variant="primary" onClick={this.close}>OK</Button>
						</Modal.Footer>
					</Modal>
				}
				{this.state.error === 110 &&
					<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
						<Modal.Header closeButton className="bg-dark">
							<Modal.Title>Please Select A Channel</Modal.Title>
						</Modal.Header>
						<Modal.Body className="bg-dark">
							<Row>
								<Col xs={4} className="text-vcenter">
									<div>
										<img src="/images/clubbers.png" width="50%" /><br />
										<Button size="sm" onClick={()=>this.channelSelect("clubbers")}>Clubbers</Button>
									</div>
								</Col>
								<Col className="text-vcenter">
									<div>
										<img src="/images/radio.png" width="50%" /><br />
										<Button size="sm" onClick={()=>this.channelSelect("radio")}>Radio</Button>
									</div>
								</Col>
								<Col className="text-vcenter">
									<div>
										<img src="/images/test.png" width="50%" /><br />
										<Button size="sm" onClick={()=>this.channelSelect("test")}>Test Center</Button>
									</div>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer className="bg-dark">
							<Button variant="secondary" onClick={this.close}>Close</Button>
							{/*<Button variant="primary" onClick={this.close}>OK</Button>*/}
						</Modal.Footer>
					</Modal>
				}
				{this.state.error === 115 &&
					<ScheduleAdd show={this.state.error===115} close={this.close} channel={this.state.channel} />
				}
			</>
		);
	}
}

